import { render, staticRenderFns } from "./trashBin.vue?vue&type=template&id=1ebf04fc&"
import script from "./trashBin.vue?vue&type=script&lang=js&"
export * from "./trashBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports